import { emptyValidator, formValidator } from "../../validators";

const documentManagementValidationStatus = {
  // tdhReferance: {
  //   validators: [emptyValidator()],
  //   name: "Reference",
  // },
  // tdhCompany: {
  //   validators: [emptyValidator()],
  //   name: "Company",
  // },
  tdhCategory: {
    validators: [emptyValidator()],
    name: "Category",
  },
  tdhInspectionType: {
    validators: [emptyValidator()],
    name: "Inspection type",
  },
  tdhTemplate: {
    validators: [emptyValidator()],
    name: "Template",
  },
  // tdhRefId: {
  //   validators: [emptyValidator()],
  //   name: "Reference",
  // },
  // tdhNextValue: {
  //   validators: [emptyValidator()],
  //   name: "Next value",
  // },
  // tdhNextUom: {
  //   validators: [emptyValidator()],
  //   name: "Next UOM",
  // },
  // tdhActionDate: {
  //   validators: [emptyValidator()],
  //   name: "Action date",
  // },
  // tdhDescription: {
  //   validators: [emptyValidator()],
  //   name: "Description",
  // },
  tdhOverall: {
    validators: [emptyValidator()],
    name: "Overall",
  },
  tdhOverallStatus: {
    validators: [emptyValidator()],
    name: "Overall status",
  },
  // tdhUom: {
  //   validators: [emptyValidator()],
  //   name: "UOM",
  // },
  // tdhNextDate: {
  //   validators: [emptyValidator()],
  //   name: "Next date",
  // },
  // tdhMillage: {
  //   validators: [emptyValidator()],
  //   name: "Millage",
  // },
  tdhTotal: {
    validators: [emptyValidator()],
    name: "Total",
  },
  tdhValue: {
    validators: [emptyValidator()],
    name: "Value/Amount",
  },
  tdhStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  tdhActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
  tdhDriverId: {
    validators: [emptyValidator()],
    name: "Driver",
  },
  thdDepreciation: {
    validators: [emptyValidator()],
    name: "Is depreciation enabled",
  },
  thdDepreciationValue: {
    validators: [emptyValidator()],
    name: "Depreciation Value",
  },
  thdDepreciationUom: {
    validators: [emptyValidator()],
    name: "Depreciation UOM",
  },
  thdDepreciationDate: {
    validators: [emptyValidator()],
    name: "Depreciation Date",
  },
};

export const documentManagementValidation = (data) => {
  return formValidator(data, documentManagementValidationStatus);
};
